export default __webpack_public_path__ + "static/media/miguel-lopes-42.7a518b57.jpg";